import { Plus } from 'lucide-react'
import { patientService } from '../../../../services/patientApi'
import { formatDay } from '../patientFormat'
import { GOAL_HORIZON, GOAL_STATUS } from './therapyFormat'

function TherapyGoals({ patientId, goals, archived, canCreate = false, onCreate, onEdit, onChanged }) {
  const toggle = (goal) => {
    const status = goal.status === 'concluida' ? 'em_andamento' : 'concluida'
    onChanged(() => patientService.updateTherapyGoal(patientId, goal.id, { status }))
  }

  return (
    <section className="therapy-block" data-onboarding="therapy-goals">
      <div className="patients-section-head">
        <div>
          <h3>Metas terapêuticas</h3>
          <p className="patients-muted">Curto e longo prazo, com o andamento de cada uma.</p>
        </div>
        {!archived && canCreate && (
          <button type="button" onClick={onCreate} className="patients-btn patients-btn--primary">
            <Plus size={14} /> Nova meta
          </button>
        )}
      </div>
      {goals.length === 0 && <p className="patients-muted">Nenhuma meta cadastrada.</p>}
      <div className="therapy-goals">
        {goals.map((goal) => (
          <article key={goal.id} className={`therapy-goal${goal.status === 'concluida' ? ' is-done' : ''}`}>
            <div>
              <span className="therapy-kicker">{GOAL_HORIZON[goal.horizon] || goal.horizon}</span>
              <h3>{goal.title}</h3>
              {goal.notes && <p className="patients-muted">{goal.notes}</p>}
              <p className="patients-muted">
                {GOAL_STATUS[goal.status] || goal.status}
                {goal.target_date ? ` · alvo ${formatDay(goal.target_date)}` : ''}
              </p>
            </div>
            {!archived && (
              <div className="therapy-card-actions">
                <button type="button" onClick={() => onEdit(goal)} className="patients-btn patients-btn--ghost patients-btn--compact">Editar</button>
                <button type="button" onClick={() => toggle(goal)} className="patients-btn patients-btn--ghost patients-btn--compact">
                  {goal.status === 'concluida' ? 'Reabrir' : 'Concluir'}
                </button>
              </div>
            )}
          </article>
        ))}
      </div>
    </section>
  )
}

export default TherapyGoals
